<template>
  <b-modal ref="deleteCompetitionModal" :title="this.competition.title() + ' löschen'">
    <p><b>ACHTUNG!</b> Der Löschvorgang kann nicht widerrufen werden. Alle Ergebnisse werden ebenfalls gelöscht.</p>
    <b-form-group label-for="date" label="Zum Bestätigen den Namen des Wettbewerbes eingeben:">
      <b-form-input type="text" v-model=confirmation ></b-form-input>
    </b-form-group>
    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" :disabled=!this.confirmed block @click="confirm">Löschen</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'DeleteCompetitionModal',
  props: ['competition'],

  data: function () {
    return {
      confirmation: ''
    }
  },

  computed: {
    confirmed: function () {
      return this.confirmation.toLowerCase() === this.competition.name.toLowerCase()
    }
  },

  methods: {
    show: function () {
      this.$refs.deleteCompetitionModal.show()
    },

    hide: function () {
      this.confirmation = ''
      this.$refs.deleteCompetitionModal.hide()
    },

    confirm: function () {
      if (!this.confirmed) {
        return
      }

      this.axios.delete('/competitions/' + this.competition.id)
        .then(() => { this.$emit('deleted-competition') })
        .catch(err => { this.$emit('alertError', err) })
        .finally(() => {
          if (this.$refs.deleteCompetitionModal) {
            this.$refs.deleteCompetitionModal.hide()
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/DeleteCompetitionModal.vue